module.exports = __webpack_public_path__ + "static/media/PopLogo.1cfaac49.png";